/*
 * @Author: wzh
 * @LastEditTime: 2022-11-01 17:16:06
 * @Description: 修改密码 index
 */
import UpdatePassword from "./updatePassword";
export { UpdatePassword };
